/**
 * Estructura de la aplicación: cabecera, contenido y navegación inferior.
 *
 * Sin lógica de negocio dentro. Solo composición.
 */

import { NavLink, Outlet } from 'react-router-dom';

import { DESTINOS_NAV, RUTA_AJUSTES } from '../../app/rutas';
import { EstadoGuardado } from '../comunes/EstadoGuardado';
import estilos from './AppLayout.module.css';

export function AppLayout() {
  return (
    <div className={estilos.contenedor}>
      <header className={estilos.cabecera}>
        <span className={estilos.marca}>English Training Hub</span>
        <div className={estilos.accionesCabecera}>
          <EstadoGuardado />
          <NavLink
            to={RUTA_AJUSTES}
            className={estilos.ajustes}
            aria-label="Ajustes"
            title="Ajustes"
          >
            <span aria-hidden="true">⚙︎</span>
          </NavLink>
        </div>
      </header>

      <main className={estilos.contenido}>
        <Outlet />
      </main>

      {/*
        La navegación NUNCA puede ser contenedor de scroll: cualquier `overflow`
        distinto de `visible` recortaría lo que contenga. Si el ancho no alcanza,
        las etiquetas se encogen; nunca se recorta.
      */}
      <nav className={estilos.nav} aria-label="Secciones principales">
        {DESTINOS_NAV.map((destino) => (
          <NavLink
            key={destino.ruta}
            to={destino.ruta}
            end={destino.ruta === '/'}
            className={({ isActive }) =>
              isActive ? `${estilos.enlace} ${estilos.activo}` : estilos.enlace
            }
          >
            {destino.etiqueta}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
